import api, { convertToISODateTime, handleApiError } from './client';
import { USER_ROLES } from '../../utils/constants';

export const registrationService = {
  /**
   * Register new user/athlete publicly
   */
  registerPublic: async (userData) => {
    try {
      const input = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        roles: userData.roles || [USER_ROLES.ATHLETE],
        dateOfBirth: convertToISODateTime(userData.dateOfBirth),
        phoneNumber: userData.phoneNumber || null,
        address: userData.address || null,
        birthMunicipality: userData.birthMunicipality || null,
        residenceMunicipality: userData.residenceMunicipality || null,
        residenceProvince: userData.residenceProvince || null,
        residencePostalCode: userData.residencePostalCode || null,
        fiscalCode: userData.fiscalCode,
        parent: userData.parent || null,
        medicalCertificate: userData.medicalCertificate
          ? {
              certificateNumber: userData.medicalCertificate.certificateNumber || null,
              issueDate: convertToISODateTime(userData.medicalCertificate.issueDate),
              expiryDate: convertToISODateTime(userData.medicalCertificate.expiryDate),
              certificateType: userData.medicalCertificate.certificateType,
              notes: userData.medicalCertificate.notes || null,
            }
          : null,
        acceptedConsentIds: userData.acceptedConsentIds || null,
        acceptedAttachmentIds: userData.acceptedAttachmentIds || null,
        acceptedSectionIds: userData.acceptedSectionIds || null,
      };

      let response;
      if (userData.medicalCertificateFile) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(input));
        formData.append('file', userData.medicalCertificateFile);
        response = await api.post('/api/registrations/public', formData);
      } else {
        response = await api.post('/api/registrations/public', input);
      }

      return {
        success: true,
        message: response.data?.message || 'Registrazione completata con successo! Si ricorda di firmare e consegnare i documenti in segreteria.',
      };
    } catch (error) {
      console.error('Register public error:', error);
      return handleApiError(error, 'Errore durante la registrazione');
    }
  },
};

export default registrationService;
